// extracted by mini-css-extract-plugin
module.exports = {"OnePicture":"OnePicture_OnePicture__LCxhC"};